<template>
    <div class="effect">
        <cough  v-if="randVal === 0" />
        <kidney v-else />
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Cough from '../../../../components/Doctor/ByEffects/Сough';
import Kidney from '../../../../components/Doctor/ByEffects/Kidney';

export default {
    components : {
        'cough' : Cough,
        'kidney' : Kidney
    },
    data : () => ({
        randVal : null
    }),
    computed : {
        ...mapGetters([
            'getByEffect'
        ])
    },
    beforeCreate(){
        this.$nextTick(() => {
            this.randVal = this.getRand();

            if(this.getByEffect !== ''){
                switch(this.getByEffect){
                    case 'Під час лікування у пацієнта з`явилися скарги на кашель, утруднене дихання, хрипи<br><br><b>Ro: затемнення нижньої долі правої легені, ознаки плевриту</b>':
                        this.randVal = 0;
                    break;
                    case 'Під час лікування у пацієнта виникла тяжка ниркова недостатність':
                        this.randVal = 1;
                }
            }

            if(this.randVal === 0)
                this.setByEffect('Під час лікування у пацієнта з`явилися скарги на кашель, утруднене дихання, хрипи<br><br><b>Ro: затемнення нижньої долі правої легені, ознаки плевриту</b>');
            else
                this.setByEffect('Під час лікування у пацієнта виникла тяжка ниркова недостатність');
        })
    },
    methods : {
        ...mapMutations([
            'setByEffect'
        ]),
        getRand(){
            return Math.random() < 0.5 ? 0 : 1;
        }
    }
}
</script>

<style lang="scss">
.effect{
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
}
</style>